import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { SITE_NAME, qrLink } from './config';
import { toast } from './feedback';

// Ảnh PNG để in: mã QR + tên tranh + mã chứng nhận + chủ sở hữu bên dưới
async function buildPrintablePng(link, artwork) {
  const qrCanvas = document.createElement('canvas');
  await QRCode.toCanvas(qrCanvas, link, { width: 600, margin: 2, errorCorrectionLevel: 'M' });

  const padding = 40;
  const width = qrCanvas.width + padding * 2;
  const height = qrCanvas.height + padding * 2 + (artwork.ownerName ? 165 : 120);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(qrCanvas, padding, padding);

  ctx.fillStyle = '#1c1917';
  ctx.textAlign = 'center';
  ctx.font = 'bold 34px -apple-system, "Segoe UI", Roboto, sans-serif';
  ctx.fillText(artwork.title, width / 2, qrCanvas.height + padding + 50, width - padding * 2);
  ctx.fillStyle = '#57534e';
  ctx.font = '26px -apple-system, "Segoe UI", Roboto, sans-serif';
  ctx.fillText(`${artwork.code} · ${SITE_NAME}`, width / 2, qrCanvas.height + padding + 95, width - padding * 2);
  if (artwork.ownerName) {
    ctx.fillText(`Chủ sở hữu: ${artwork.ownerName}`, width / 2, qrCanvas.height + padding + 140, width - padding * 2);
  }
  return canvas.toDataURL('image/png');
}

export default function QrDialog({ artwork, onClose }) {
  const link = qrLink(artwork.qrToken);
  const [preview, setPreview] = useState('');

  useEffect(() => {
    QRCode.toDataURL(link, { width: 280, margin: 1, errorCorrectionLevel: 'M' }).then(setPreview);
  }, [link]);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const download = async () => {
    const a = document.createElement('a');
    a.href = await buildPrintablePng(link, artwork);
    a.download = `QR-${artwork.code}.png`;
    a.click();
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast('Đã sao chép link');
    } catch {
      window.prompt('Sao chép link này:', link);
    }
  };

  return (
    <div className="dialog-backdrop" onClick={onClose}>
      <div className="dialog qr-dialog" onClick={(e) => e.stopPropagation()} role="dialog" aria-label={`Mã QR của ${artwork.title}`}>
        <h2>{artwork.title}</h2>
        <p className="muted">
          {artwork.code}
          {artwork.ownerName && (
            <>
              <br />
              Chủ sở hữu: {artwork.ownerName}
            </>
          )}
        </p>
        {preview ? <img className="qr-image" src={preview} alt="Mã QR" /> : <div className="qr-image" />}
        <a className="qr-link" href={link} target="_blank" rel="noreferrer">
          {link}
        </a>
        <div className="dialog-actions">
          <button className="primary" onClick={download}>
            Tải ảnh QR
          </button>
          <button onClick={copy}>Sao chép link</button>
          <button onClick={onClose}>Đóng</button>
        </div>
      </div>
    </div>
  );
}
